export default __webpack_public_path__ + "static/media/ars-maquette-bold-webfont.7f6d5ab9.eot";